export function measures(state, data) {
  state.measures = data
}

export function landApplications(state, data) {
  state.landApplications = data
}

export function shaftApplications(state, data) {
  state.shaftApplications = data
}
